module.exports = __webpack_public_path__ + "static/media/nalas.84cd39aa.png";